<div class="course-summary">
  <div class="course-summary__title" [attr.data-qa]="'courseDetailsTitle'" i18n>Course details</div>
  <div class="course-summary__section">
    <div class="course-summary__section__title" i18n>Location</div>
    <div class="course-summary__section__description" [attr.data-qa]="'location_country'">{{ schoolLocation?.countryName }}</div>
    <div class="course-summary__section__description" [attr.data-qa]="'location_city'">{{ schoolLocation?.schoolName }}</div>
  </div>
  <div class="course-summary__section">
    <div class="course-summary__section__title" i18n>Study Period</div>
    <div class="course-summary__section__description" [attr.data-qa]="'studyStartDate'">
      {{ startDate | lxStudyPeriod : endDate : duration : (activeFlow === Flows.Aya ? DurationUnitEnum.MONTH : DurationUnitEnum.WEEKS) }}
    </div>
  </div>
  <div class="course-summary__section">
    <div class="course-summary__section__title" i18n>Course</div>
    <div class="course-summary__section__description" [attr.data-qa]="'courseDetailsName'">{{ course?.name }}</div>
  </div>
</div>
